import React, { useEffect, useRef, useState } from 'react'
import { useStores } from '../../../stores/store'
import { Link } from 'react-router-dom';
import { FaEdit } from 'react-icons/fa';
import { Table } from '../../common/table';
import { Pagination } from '../../common/pagination';
import { useTranslation } from 'react-i18next';
import Loader from '../../common/loader';

const LS_KEY = 'school_users_pageSize';

function SchoolUsersPage() {
  const { auth } = useStores();
  const { t, i18n } = useTranslation();

  const searchKey = useRef<string>("");
  const searchRef = useRef(null);

  const [isDataError, setIsDataError] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(() => {
    const saved = localStorage.getItem(LS_KEY);
    return saved ? +saved : 50;
  });

  useEffect(() => {
    searchKey.current = localStorage.getItem('school_users_searchKey');
    getUsers();
  }, [])

  const getUsers = (page = 1, size = pageSize) => {
    setIsDataLoading(true);
    setIsDataError(false);

    auth.getUsers(2, searchKey.current, page, size).then((res) => {
      setUsers(res.data.results || []);
      setTotalCount(res.data.count || 0);
      setCurrentPage(page);
      setIsDataLoading(false);
    }).catch((error) => {
      setIsDataLoading(false);
      setIsDataError(true);
    });
  }

  const totalPages = Math.ceil(totalCount / pageSize);

  const handlePageSizeChange = (size: number) => {
    setPageSize(size);
    localStorage.setItem(LS_KEY, String(size));
    getUsers(1, size);
  };
    
  const columns = React.useMemo(
      () => [
      {
          Header: t('users'),
          columns: [
            {
              Header: t('modify'),
              accessor: "id",
              Cell: ({ cell }) => (
                <Link to={
                    `/school/users/${cell.row.values.id}`}>
                  <FaEdit />
                </Link>
              )
            },
            {
                Header: t('companyName'),
                accessor: 'surname',
            },
          ],
      },
      {
        Header: "Login",
        columns: [
        {
            Header: t('email'),
            accessor: 'email',
        },
        {
          Header: t('type'),
          accessor: 'type',
          Cell: ({ cell }) => (
            cell.row.values.type == 1 ? <span>{t('admin')}</span> : 
            cell.row.values.type == 2 ? <span>{t('professor')}</span> : 
            cell.row.values.type == 3 ? <span>{t('school')}</span> : 
            cell.row.values.type == 4 ? <span>{t('demo')}</span> :
            cell.row.values.type == 5 ? <span>{t('partner')}</span> : <span></span>
          )
        },
        {
          Header: t('active'),
          accessor: "is_old",
          Cell: ({ cell }) => (
            cell.row.values.is_old ? t('no') : t('yes')
          )
        },
        ],
    },
    ],
      []
  );

  if (isDataLoading)
    return <div className='grid h-screen place-items-center'><Loader /></div>

  if (isDataError)
    return <div className='grid h-screen place-items-center'>{t('cannotLoadPage')}</div>

  const paginationControls = (
    <Pagination
      currentPage={currentPage}
      totalPages={totalPages}
      pageSize={pageSize}
      onPageChange={(page) => getUsers(page)}
      onPageSizeChange={handlePageSizeChange}
    />
  );

  return (
    <div className="flex flex-col px-12">
      <div className="flex flex-row justify-between items-center">
          <span className="text-4xl">{t('users')}</span>
          <Link className="bg-primary hover:bg-blue-700 text-white font-bold p-4 rounded-full mt-4" to="/school/users/new">{t('add')}</Link>
      </div>

      {paginationControls}

      <Table columns={columns} data={users} />

      <div className="mt-4">{paginationControls}</div>
    </div>
  )
}

export default SchoolUsersPage;
